import PropTypes from 'prop-types'

const userPropTypes = PropTypes.shape({
    id: PropTypes.string.isRequired,
    profile: PropTypes.shape({
        nickname: PropTypes.string.isRequired,
        avatar: PropTypes.string.isRequired,
    }),
    treesPlantedTotal: PropTypes.number.isRequired,
    treesPlantedMonthly: PropTypes.number.isRequired,
    trees: PropTypes.number,
})

export default userPropTypes
